import "../calcite-icon/index.js";
export * from "./customElement.js";